import type { Product } from '../../models/Product';
import Icon from '../icon/Icon';
import type { IconId } from '../icon/icons';
import ProductMiniatureList from '../product/miniature/ProductMiniatureList';
import './AssistantChatMessageFeature.less';

export type AssistantChatMessageFeatureProps = {
    className?: string;
    iconId: IconId;
    text: string;
    quantity?: number;
    products?: Product[];
    onClick?: () => void;
};

const AssistantChatMessageFeature = ({
    className = '',
    iconId,
    text,
    quantity,
    products,
    onClick
}: AssistantChatMessageFeatureProps) => (
    <div
        className={`bri-AssistantChatMessageFeature ${className}`}
        onClick={onClick}
    >
        <div className="bri-AssistantChatMessageFeature-icon">
            <Icon iconId={iconId} size="medium" />
        </div>
        <div className="bri-AssistantChatMessageFeature-text bri-DisplayFont">
            {text}
            {quantity !== undefined && (
                <span className="bri-AssistantChatMessageFeature-quantity">
                    &nbsp;({quantity})
                </span>
            )}
        </div>
        {products && products.length > 0 && (
            <div>
                <ProductMiniatureList
                    products={products}
                    size="x-small"
                    maxProductsToShow={3}
                />
            </div>
        )}
    </div>
);

export default AssistantChatMessageFeature;
